import NoFindPage from "./NoFindPage";

export default NoFindPage;
